import React, { type ReactNode } from 'react';
import { DialogHeading } from '@ariakit/react';
import { Drawer } from 'vaul';
import { Paragraph as P } from '@periodica/ui-kit';
import { useModalContext } from '../ModalContext';
import * as styles from './index.module.css';

export type DialogHeaderProps = { title: string | ReactNode; description?: string };

export function Header({ title, description }: DialogHeaderProps) {
  const { isDrawer } = useModalContext();

  const HeaderWrapper = isDrawer ? Drawer.Title : DialogHeading;

  return (
    <div className={styles.modalHeader}>
      <HeaderWrapper className={styles.modalHeaderTitle}>{title}</HeaderWrapper>
      {description && <P>{description}</P>}
    </div>
  );
}
